import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="relative w-10 h-10 flex items-center justify-center flex-shrink-0">
                <div className="absolute" style={{ width: 0, height: 0, borderLeft: '11px solid transparent', borderRight: '3px solid transparent', borderBottom: '36px solid #ffffff', top: 2, left: 3, transform: 'rotate(-8deg)' }} />
                <div className="absolute" style={{ width: 0, height: 0, borderLeft: '3px solid transparent', borderRight: '11px solid transparent', borderBottom: '36px solid #dc2626', top: 2, right: 3, transform: 'rotate(8deg)' }} />
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-black text-xl tracking-tight text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  MAX<span className="text-red-500">SAILS</span>
                </span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-white/40 mt-0.5">Canada</span>
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-4">{t('footer_desc')}</p>
            <div className="flex items-center gap-3">
              <a href="mailto:contact@MAXSails.ca" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-red-600 transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm" />
              </a>
              <a href="tel:+18193031365" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-red-600 transition-colors cursor-pointer">
                <i className="ri-phone-line text-sm" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-stone-400 mb-5">{t('footer_nav_title')}</h4>
            <ul className="space-y-3">
              {[
                { labelKey: 'nav_home', to: '/' },
                { labelKey: 'nav_products', to: '/products' },
                { labelKey: 'nav_contact', to: '/contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-stone-300 hover:text-white text-sm transition-colors cursor-pointer">
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-stone-400 mb-5">{t('footer_contact_title')}</h4>
            <ul className="space-y-3 text-sm text-stone-300">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-red-500 flex-shrink-0" />
                <a href="tel:+18193031365" className="hover:text-white transition-colors cursor-pointer">+1 (819) 303-1365</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-red-500 flex-shrink-0" />
                <a href="mailto:contact@MAXSails.ca" className="hover:text-white transition-colors cursor-pointer">contact@MAXSails.ca</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">
            {t('footer_copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
